/* Renamed this from CursorPageUnionFileReadWithUrlDirectoryItemsInner to CursorPageUnionFileReadWithUrlItemsInner because only that one is exported from the generated API client. Not sure if it's the way to go though. */
import { ItemsInner } from "@nens/rana/api-v1";
export interface ProjectFile extends ItemsInner {
  type: "file";
}

export interface ProjectDirectory extends ItemsInner {
  type: "directory";
}

export type ProjectFileOrDirectory = ItemsInner;

export const isProjectFile = (item: ProjectFileOrDirectory): item is ProjectFile => {
  return item.type === "file";
};
